import { BillingNoteGenerationStatus } from "~/providers/utils/types/patientBillingNoteTypes";

export const BILLING_NOTE_GENERATION_STATUS = {
  pending: "PENDING",
  in_progress: "IN_PROGRESS",
  completed: "COMPLETED",
  failed: "FAILED",
} as const;

export const billingNoteGenerationStatusMessages: Record<
  BillingNoteGenerationStatus,
  string
> = {
  PENDING: "Billing note is being generated. This may take a few minutes.",
  IN_PROGRESS: "Billing note is being generated. This may take a few minutes.",
  COMPLETED: "",
  FAILED:
    "Billing note generation failed. You can complete the note manually below.",
};
